import { createSelector } from 'reselect';

const selectAmostrasState = (state) => state.amostras;

export const makeSelectAmostraByItemId = (id) =>
  createSelector([selectAmostrasState], (amostras) => {
    return amostras[id] || null;
  });
